// extracted by mini-css-extract-plugin
export default {"wrapper":"FailureViewAttachedSection_wrapper__lSXXy","divider":"FailureViewAttachedSection_divider__gciPH"};